import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormFieldComponent } from './form-field.component';

@NgModule({
  declarations: [FormFieldComponent],
  exports: [FormFieldComponent],
  imports: [CommonModule],
})
export class FormFieldModule {}

export { FormFieldComponent } from './form-field.component';
